import {load} from 'recaptcha-v3';

const SITE_KEY_V3 = '6LeyXKkZAAAAAPO84TovLXsDWzijSKp_-0RWng0W';

let recaptchaInstance;

load(SITE_KEY_V3, {
    useRecaptchaNet: true,
    autoHideBadge: true
}).then((recaptcha) => {
    recaptchaInstance = recaptcha;
});

export const getRecaptchaToken = (action) => {
    return recaptchaInstance.execute(action).then((token) => {
        return token;
    });
};

export const addRecaptchaToken = (payload, token) => {
    return {...payload, reCaptcha: token}
};
